<template>
    <SidebarWrapper>
      <ul class="flex-grow">
        <li
          v-for="({routeCode, label, role, feature}) in siteSettings.authorizedLinks"
          :key="`${routeCode}_${label}`"
          :class="{ 'hidden': (role === 'supplier' && !auth.idSupplier) || (feature && !configs[feature]) }"
        >
          <span
            class="block py-3 px-5 md:px-8 text-sm font-semibold text-bolder transition duration-200 hover:text-accent hover:underline cursor-pointer"
            @click="() => handleClick(routeCode)"
          >
            {{ $t(label) }}
          </span>
        </li>
      </ul>
    </SidebarWrapper>
</template>

<script setup>
import { siteSettings } from "@settings/site.settings";
import { useAuthStore } from '@stores/auth';
import { useConfigStore } from '@stores/config';
import SidebarWrapper from "@components/common/sidebar/sidebar-wrapper";

const { $eventBus } = useNuxtApp();
const auth = useAuthStore();
const configs = useConfigStore();

const closeSidebar = () => {
    $eventBus.emit('sidebar:close');
}

const handleClick = async (routeCode) => {
    closeSidebar();
    await navigatorTo(translatePath(routeCode));
}
</script>
